import { cn } from "@/app/utils/className";

interface CardProps {
  children: React.ReactNode;
  className?: string;
  bgClassName?: string;
  showCornerAccent?: boolean;
  showHoverLineAccent?: boolean;
  accentLinePosition?: "bottom" | "top";
}

export const Card = ({
  children,
  className,
  bgClassName,
  showCornerAccent = true,
  showHoverLineAccent = true,
  accentLinePosition = "bottom",
}: CardProps) => {
  return (
    <div
      className={cn(
        "group relative h-full bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8 hover:bg-white/10 transition-all duration-500 hover:border-white/20 hover:scale-[1.02]",
        className
      )}
    >
      {/* Gradient glow effect */}
      <div
        className={cn(
          `absolute inset-0 bg-gradient-to-br opacity-0 group-hover:opacity-20 rounded-2xl blur-xl transition-opacity duration-500`,
          bgClassName
        )}
      ></div>

      {/* Content */}
      <div className="relative z-10">{children}</div>

      {/* Hover accent line */}
      {showHoverLineAccent && (
        <div
          className={cn(
            "absolute left-0 w-full h-1 bg-gradient-to-r from-transparent via-white/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-b-2xl",
            {
              "top-0": accentLinePosition === "top",
              "bottom-0": accentLinePosition === "bottom",
            }
          )}
        ></div>
      )}

      {/* Corner accents */}
      {showCornerAccent && (
        <>
          <div className="absolute top-4 right-4 w-8 h-8 border-t-2 border-r-2 border-white/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
          <div className="absolute bottom-4 left-4 w-8 h-8 border-b-2 border-l-2 border-white/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        </>
      )}
    </div>
  );
};
